import React, {
  Dispatch, SetStateAction, createContext, PropsWithChildren, useContext, useState
} from 'react';
import {InvoiceMatch} from "../types";

export type MatchedInvoicesRow = {
  id: number;
  createdAt: Date;
  amount: number;
  description: string;
  matchedCount: number;
  matchedInvoices: InvoiceMatch[];
  isUsed?: boolean
}

type BankStatementsGeneralContext = {
  tableRows: MatchedInvoicesRow[],
  setTableRows: Dispatch<SetStateAction<MatchedInvoicesRow[]>>;
}

interface BankStatementsGeneralProviderProps extends PropsWithChildren<{}> {}

const BankStatementsGeneralContext = createContext<BankStatementsGeneralContext>({
  tableRows: [],
  setTableRows: () => {}
});

export function useBankStatementsGeneralContext() {
  return useContext(BankStatementsGeneralContext);
}

export function BankStatementsGeneralProvider({children}: BankStatementsGeneralProviderProps) {
  const [tableRows, setTableRows] = useState<MatchedInvoicesRow[]>([]);

  return (
    <BankStatementsGeneralContext.Provider value={{
      tableRows,
      setTableRows,
    }}>
      {children}
    </BankStatementsGeneralContext.Provider>
  );
}
